import { isRejectedWithValue } from '@reduxjs/toolkit';

import { analytics } from 'applications/GSP/app/providers/AnalyticsProvider';
import { AnalyticsEvent } from 'applications/GSP/shared/constants/analytics';
import { IS_DEVELOPMENT } from 'shared/config/env';
import { notify } from 'shared/utils/common';

import type { Middleware } from '@reduxjs/toolkit';

const DEFAULT_NOTIFY_MESSAGE = {
  header: 'Oops, well this is embarrassing!',
  description:
    'We are having trouble getting your information. Please, reload the page or try again later.',
};

export const rtkQueryErrorLogger =
  (header: string, description: string): Middleware =>
  () =>
  next =>
  action => {
    if (isRejectedWithValue(action)) {
      const { payload: error } = action;

      if (IS_DEVELOPMENT) {
        window.console.error(`${AnalyticsEvent.APIError}:`, error);
      }

      analytics.track(AnalyticsEvent.APIError, { error });

      notify.error({
        header: header || DEFAULT_NOTIFY_MESSAGE.header,
        description: description || DEFAULT_NOTIFY_MESSAGE.description,
      });
    }

    return next(action);
  };
